/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const ChevronsUpIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
    <path
      d="M15.908 16.7899L20.6997 11.9982L15.908 7.20654M9.19971 16.7899L13.9914 11.9982L9.19971 7.20654"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.30013 16.7899L7.0918 11.9982L2.30013 7.20654"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
